var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import 'jspdf-autotable';
import 'svg2pdf.js';
import { GraficoPDF } from './GraficoPDF';
/**
 * Gera um componente para o PDF do gráfico de Barra
 */
export default class GraficoBarraPDF extends GraficoPDF {
    constructor(config, svg, title, legendData, marginBottom = 0, isHorizontal) {
        super(config, svg, title, legendData);
        this.marginBottom = marginBottom;
        this.isHorizontal = isHorizontal;
    }
    /**
     * Gera o componente do gráfico de Barra
     * @param docObj PDF
     * @returns Promise<ComponentPDF | null> Componente do gráfico de barra
     */
    criarGrafico(docObj) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isHorizontal) {
                return yield this.configurarGrafico(docObj, 260, 65, null, 'center', 'center', this.marginBottom);
            }
            return yield this.configurarGrafico(docObj, 200, 55, null, 'left', 'center', this.marginBottom);
        });
    }
}
